<style src="./EditableTagLabel.scss" lang="scss" scoped></style>
<template>
  <label
    @click.stop="editValue"
    class="editable-tag-label"
    :title="hint">

    <span class="title">{{ title }}</span>
    <span
      v-show="!editMode"
      class="value">{{ value | nonexistsText }}</span>
    
    <div
      v-click-outside="cancelEdition"
      v-if="editMode"
      class="edit-mode">
      <input
        ref="editTagInputValue"
        @blur="cancelEdition"
        class="edittextbox"
        v-shortkey="{ save: ['enter'], cancel: ['esc'] }"
        @shortkey="editAction"
        v-model="form.editValue" />
    </div>
  </label>
</template>

<script>
export default {
  name: 'EditableTagLabel',
  props: {
    title: String,
    value: String,
    hint: String
  },
  data () {
    return {
      editMode: false,
      form: {
        editValue: ''
      }
    }
  },
  filters: {
    nonexistsText (v) {
      if (!v) {
        return 'SEM CÓDIGO'
      }
      return v
    }
  },
  methods: {
    editValue () {
      this.form.editValue = this.value
      this.editMode = true
      this.$nextTick(() => {
        this.$refs.editTagInputValue.focus()
      })
    },
    editAction (mode) {
      switch (mode.srcKey) {
        case 'save':
          this.saveEdition()
          break
        case 'cancel':
          this.cancelEdition()
      }
    },
    saveEdition () {
      this.$emit('save-edition', this.form.editValue)
      this.cancelEdition()
    },
    cancelEdition () {
      this.editMode = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/components/editable-tag-label/EditableTagLabel.vue